<template>
  <div>
    <Row :gutter="8" class="m-b-10">
      <i-col span="6">
        <i-input size="small" v-model="query.keyWord" clearable placeholder="关键字：支持合同编号、合同名称"></i-input>
      </i-col>
      <i-col span="10">
        <Button type="primary" icon="ios-search" size="small" @click="onSearchData">搜索</Button>
        <Button type="success" icon="md-cloud-upload" class="m-l-5" size="small" @click="handleExportMeter">导入电表数据</Button>
      </i-col>
    </Row>
    <Table stripe size="small" :data="tableData" :columns="tableColumns"></Table>
    <div class="paging_style">
      <Page size="small" :total="totalRow" :page-size="query.size" show-total show-elevator
        :current="query.current" @on-change="handleChangePage"></Page>
    </div>

    <Modal v-model="meterExportDataModal" title="导入电表数据" footer-hide width="400">
      <Row class="m-b-20">
        <i-col flex="80px">模版下载</i-col>
        <i-col flex="auto">
          <a @click="handleDownloadTemplete">电表读数记录导入模板表.xlsx</a>
        </i-col>
      </Row>
      <Row>
        <i-col flex="80px">数据上传</i-col>
        <i-col flex="auto">
          <Upload
            type="drag"
            :action="uploadUrl"
            :headers="uploadHeaders"
            :show-upload-list="false"
            :on-success="onExportSuccess">
              <div style="padding: 20px 0">
                  <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                  <p>点击或者拖拽文件上传</p>
              </div>
          </Upload>
        </i-col>
      </Row>
      <Row v-if="errorMsg" class="m-t-5">
        <i-col flex="80px"> </i-col>
        <i-col flex="auto">
          <span class="text-orange">{{ errorMsg }}</span>
        </i-col>
      </Row>
    </Modal>
  </div>
</template>

<script>
import { getStorage } from '@/utils/storage'
import { downloadFileRequest } from '@/utils/download'

import { pgeElectricMetricContract, updateAmountByContractId } from '@/api/invest/electricMeterRecord'
import { updateLineLost } from '@/api/invest/contract'

export default {
  data () {
    return {
      meterExportDataModal: false,
      showErrorMsg: false,
      errorMsg: '',
      uploadUrl: process.env.VUE_APP_API_URL_V2 + '/ooh-invest/electricMeterRecord/upload',
      uploadHeaders: {
        'ooh-auth': getStorage('ooh-token')
      },

      query: {
        current: 1,
        size: 15,
        keyWord: null
      },

      totalRow: 0,
      tableData: [],
      tableColumns: [
        { title: '合同编号', key: 'contractCode' },
        { title: '合同名称', key: 'contractName' },
        { title: '合同开始日期', key: 'startDate' },
        { title: '合同结束日期', key: 'endDate' },
        {
          title: '线损',
          width: '150',
          render: (h, params) => {
            const showlabel = params.row.lineLost

            const editButton = h('Icon', {
              domProps: {
                title: '编辑合同线损'
              },
              props: { type: 'md-create', size: 16, color: '#2d8cf0' },
              style: { 'margin-left': '8px', cursor: 'pointer' },
              on: {
                click: () => {
                  this.handleEditLineLost(params.row)
                }
              }
            })

            return h('div', [showlabel, editButton])
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 130,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { marginRight: '5px' },
                on: {
                  click: () => {
                    this.$store.commit('set_investment_elec_consumption_contractId', params.row.contractId)
                    this.$store.commit('set_investment_elec_consumption_pageType', 'detail')
                  }
                }
              }, '查看详情')
            ])
          }
        }
      ]
    }
  },
  mounted () {
    this.initPageData()
  },
  methods: {
    initPageData () {
      pgeElectricMetricContract(this.query).then(res => {
        this.tableData = res.records
        this.totalRow = res.total
      })
    },
    onSearchData () {
      this.query.current = 1
      this.initPageData()
    },
    handleChangePage (currentPage) {
      this.query.current = currentPage
      this.initPageData()
    },
    handleEditLineLost (params) {
      let lineLost = params.lineLost

      this.$Modal.confirm({
        title: '自定义合同线损',
        render: (h) => {
          const showContent = h('p',
            {
              style: { 'margin-top': '8px', color: '#e96900' }
            },
            'PS：当前修改仅影响未缴费的数据，已缴费的数据修改请联系管理员！！'
          )

          const inputContent = h('Input', {
            props: {
              value: lineLost,
              autofocus: true,
              placeholder: '请填写新的合同线损'
            },
            on: {
              input: (val) => {
                lineLost = val
              }
            }
          })

          return h('div', [inputContent, showContent])
        },
        loading: true,
        onOk: () => {
          updateLineLost({
            contractId: params.contractId,
            lineLost: lineLost
          }).then((res) => {
            if (res && !res.errcode) {
              // 当线损修改后，需要同步更新历史未缴费电表读数记录中的用电量和金额
              updateAmountByContractId({ contractId: params.contractId }).then(res => {
                this.$Notice.success({ desc: '编辑合同线损成功！' })
                this.onSearchData()
              })
            }
            this.$Modal.remove()
          })
            .catch((error) => {
              this.$Modal.remove()
              this.$Notice.error({
                title: '服务器请求错误',
                desc: error
              })
            })
        }
      })
    },
    handleDownloadTemplete () {
      const fileName = '电表读数记录导入模板表.xlsx'

      downloadFileRequest(process.env.VUE_APP_API_URL_V2 + '/ooh-invest/electricMeterRecord/exportTemplate',
        {}, fileName)
    },
    handleExportMeter () {
      this.showErrorMsg = false
      this.errorMsg = ''
      this.meterExportDataModal = true
    },
    onExportSuccess (res) {
      if (!res.success && res.errmsg) {
        this.errorMsg = '导入异常! 错误提示：' + res.errmsg
      } else {
        this.meterExportDataModal = false
        this.$Notice.success({
          desc: '电表数据导入成功，请及时验证数据！'
        })
        this.onSearchData()
      }
    }
  }
}
</script>
